import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
enum EffectiveConnectionType {
    "slow-2g",
    "2g",
    "3g",
    "4g"
   
};
@Injectable({ providedIn: 'root' })
export class SpeedService {
    public config:any = {};
    public dataEmittedSub = new BehaviorSubject<any>({});
    static readonly EffectiveConnectionType = EffectiveConnectionType;
    constructor(){
        this.config.imageAddr = '/assets/images/speed.jpg';
        this.config.downloadSize = 684975; //bytes
        this.config.speedCheckTime = 120000;//  2 minute 
        this.initData();
    }
    MeasureConnectionSpeed() {
        
        var download = new Image();
        this.config.startTime = (new Date()).getTime();
        download.onload = ()=>{
            this.config.endTime = (new Date()).getTime();
            
           
            var duration = (this.config.endTime - this.config.startTime) / 1000;
            var bitsLoaded = this.config.downloadSize * 8;
            this.config.speedBps = (bitsLoaded / duration).toFixed(2);
            this.config.speedKbps = (this.config.speedBps / 1024).toFixed(2);
            this.config.speedMbps = (this.config.speedKbps / 1024).toFixed(2);
            this.config.connectionType = this.getConnectionType(this.config.speedKbps);
            this.config.speedType = this.getSpeedType(this.config.connectionType);
            if(this.config.speedKbps <=  700){
                this.config.speedSlow = true;
                this.config.slowCount++;
            }else{
                this.config.speedSlow = false;
            }
            this.startTest();
            this.showResults();
        }
        
        download.onerror = (err, msg) =>{
            this.config.speedMbps = 0;
            this.config.speedSlow = true;
            this.config.slowCount++;
            this.startTest();
            console.error("Invalid image, or error downloading");
        }
        var cacheBuster = "?nnn=" + this.config.startTime;
        download.src = this.config.imageAddr + cacheBuster;
        
         
    }
    showResults() {
       this.dataEmittedSub.next(this.config);
    }
    getConfig(): Observable<any> {
        return this.dataEmittedSub.asObservable();
    }

    startTest(){
        
        if((navigator as any).connection != undefined){
            (navigator as any).connection.onchange = ()=>{
                this.startTest();
            };
            var connObj:any = (navigator as any).connection;
            this.config.speedMbps = connObj.downlink;
            this.config.speedKbps = this.config.speedMbps* 1024 ;
            this.config.connectionType = this.getConnectionType(this.config.speedKbps);
            this.config.speedType = this.getSpeedType(this.config.connectionType);
            this.showResults();
        }else{
            clearTimeout(this.config.timeId);
            if(this.config.slowCount < 3){
                this.config.timeId = setTimeout(() => {
                    this.MeasureConnectionSpeed();
                },this.config.speedCheckTime);
            }else{
                this.config.testStopped = true;
            }
        }
       
    }

    reTest(){
        this.initData();
        this.startTest();
    }

    initData(){
        this.config.speedSlow = false;
        this.config.slowCount = 0;
        this.config.testStopped = false;
    }

    getConnectionType(speedKbps){
       
        var speedType;
        if(speedKbps <=50){
            speedType = EffectiveConnectionType[0];
        }else if(speedKbps <=70){
            speedType = EffectiveConnectionType[1];
        }else if(speedKbps <=700){
            speedType = EffectiveConnectionType[2];
        }else if(speedKbps > 700){
            speedType = EffectiveConnectionType[3];
        }
        return speedType;
    }

    getSpeedType(connectionType){
        if(connectionType == EffectiveConnectionType[0] || connectionType == EffectiveConnectionType[1]){
            return 'slow';
        }else if(connectionType == EffectiveConnectionType[2]){
            return 'medium';
        }else{
            return 'high';
        }
    }
}